import React from "react";
import ReactQuill from "react-quill";
import ReactTooltip from "react-tooltip";
import { RangeStatic } from "quill";

import TTSDebouncer from "../../foundation/TTSDebouncer";

import "./RichText.scss";
import "react-quill/dist/quill.core.css";
import "react-quill/dist/quill.snow.css";

interface RichTextProps {
    id?: string;
    value: any;
    placeholder?: string;
    className?: string;
    style?: React.CSSProperties;
    minEdit?: boolean;
    disabled?: boolean;
    messenger?: boolean;
    fullWidth?: boolean;
    "data-tip"?: string | null;
    "data-place"?: string;
    "data-html"?: boolean;
    onChange?: (html: string) => void;
    onFocus?: (range: RangeStatic | null) => void;
    onBlur?: (previousRange: RangeStatic | null) => void;
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLSpanElement>) => void;
    onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
    onDoubleClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

interface RichTextState {
    visible: boolean;
    ref: React.RefObject<ReactQuill>;
    displayToolbar: any;
    displayFormats: any;
}

const tooltipDebouncer = new TTSDebouncer(100);

class RichText extends React.Component<RichTextProps, RichTextState> {
    modules = {
        toolbar: [
            [{ font: [] }],
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            [{ color: [] }, { background: [] }],
            ["link", "image"],
        ],
    };
    modulesMin = {
        toolbar: [
            [{ font: [] }],
            [{ size: ["small", false, "large", "huge"] }],
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
        ],
    };
    formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "align",
        "color",
        "background",
        "link",
        "image",
    ];

    state = {
        visible: false,
        ref: React.createRef<ReactQuill>(),
        displayToolbar: null,
        displayFormats: null,
    };

    static getDerivedStateFromProps(
        props: RichTextProps,
        state: RichTextState,
    ): RichTextState {
        tooltipDebouncer.call(ReactTooltip.rebuild);

        return state;
    }

    render(): React.ReactNode {
        return (
            <span
                className={`rich-text${this.props.fullWidth ? " full" : ""}${
                    this.props.minEdit ? " min-edit" : ""
                }${this.props.className ? ` ${this.props.className}` : ""}`}
                onClick={event => this.props.onClick?.(event)}
                onDoubleClick={event => this.props.onDoubleClick?.(event)}
                onKeyDownCapture={event => this.props.onKeyDown?.(event)}>
                <ReactQuill
                    ref={this.state.ref}
                    theme="snow"
                    readOnly={this.props.disabled}
                    modules={
                        this.props.minEdit ? this.modulesMin : this.modules
                    }
                    formats={this.formats}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    onFocus={range => this.props.onFocus?.(range)}
                    onBlur={previousRange => this.props.onBlur?.(previousRange)}
                    onKeyPress={event => this.props.onKeyPress?.(event)}
                    onKeyUp={event => this.props.onKeyUp?.(event)}
                    onChange={value => this.props.onChange?.(value)}
                />
            </span>
        );
    }
}

export default RichText;
